import { render, staticRenderFns } from "./WelcomeBonus.vue?vue&type=template&id=12cdf2e1&"
import script from "./WelcomeBonus.vue?vue&type=script&lang=js&"
export * from "./WelcomeBonus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports